import { render, staticRenderFns } from "./AddressChunk.vue?vue&type=template&id=304d251f"
import script from "./AddressChunk.vue?vue&type=script&lang=js"
export * from "./AddressChunk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports